import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import {
  ChatJoinRequest,
  GroupChatJoinRequest,
  GroupMessageRequest,
  MentionAIRequest,
  MessageRequest,
  MessageResponse,
  MissionGameChatJoinRequest,
  MissionGameChatSendMessageRequest,
  SendAIChatRequest,
  SendAIDefaultRequest,
} from '~/types';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);

export const SendMessage = (
  webSocket: React.RefObject<WebSocket>,
  message:
    | ChatJoinRequest
    | GroupChatJoinRequest
    | SendAIDefaultRequest
    | SendAIChatRequest
    | MessageRequest
    | GroupMessageRequest
    | MentionAIRequest
    | MissionGameChatJoinRequest
    | MissionGameChatSendMessageRequest,
  setMessages?: React.Dispatch<React.SetStateAction<MessageResponse[]>>,
) => {
  if (!webSocket.current) return;

  if (webSocket.current.readyState === WebSocket.OPEN) {
    const jsonData = JSON.stringify(message);

    if (setMessages && 'message' in message) {
      const msgTemplate = {
        msg: message.message,
        send_time: 'latest',
        isPending: true,
        id: message.email,
        chat_id: message.chat_id,
      };
      setMessages((prev) => [...prev, msgTemplate]);
    }
    webSocket.current.send(jsonData);
  }
};

export const SendAiMentionMessage = (
  webSocket: React.RefObject<WebSocket>,
  message: GroupMessageRequest,
  setMessages?: React.Dispatch<React.SetStateAction<MessageResponse[]>>,
) => {
  if (!webSocket.current) return;

  if (webSocket.current.readyState === WebSocket.OPEN) {
    const jsonData = JSON.stringify(message);

    if (setMessages && 'message' in message) {
      setMessages((prev) => {
        if (message.chat_id) {
          const target = prev.some((el) => el.chat_id === message.chat_id);
          if (target) {
            return [...prev];
          }
        }

        return [
          ...prev,
          {
            msg: message.message,
            send_time: 'latest',
            isPending: true,
            id: message.email,
            chat_id: message.chat_id,
          },
        ];
      });
    }
    webSocket.current.send(jsonData);
  }
};

export const formatSendTime = (sendTime?: 'error' | string) => {
  if (!sendTime) return '';

  if (sendTime === 'error') return '';

  const localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const now = dayjs();
  const messageTime = dayjs.utc(sendTime).tz(localTimeZone);

  const diffInHours = now.diff(messageTime, 'hour');
  const diffInDays = now.diff(messageTime, 'day');

  if (diffInHours < 24) {
    // 1. 연락한지 하루 미만이면 시간으로 표시
    return messageTime.format('hh:mm A');
  } else if (diffInHours >= 24 && diffInHours < 48) {
    // 2. 연락한지 24시간 초과, 48시간 미만이면 Yesterday로 표시
    return 'Yesterday';
  } else {
    // 3. 연락한지 48시간 이상이면 날짜로 표시 (예: JUL 21)
    return messageTime.format('MMM DD');
  }
};
